var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 0.803131H2.57143C1.15127 0.803131 0 1.9544 0 3.37456V17.0889C0 18.509 1.15127 19.6603 2.57143 19.6603H5.6143L5.14803 23.8517C5.09605 24.3222 5.43535 24.7458 5.90589 24.7978C6.14887 24.8246 6.39175 24.7464 6.57346 24.5829L12.0437 19.6603H21.4286C22.8487 19.6603 24 18.509 24 17.0889V3.37456C24 1.9544 22.8487 0.803131 21.4286 0.803131Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.c30105ad45530a2cd6259a0076a96683.svg";
export { ForwardRef as ReactComponent };